<ng-container thr-parent-form>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                {{ 'form.documents' | translate }}

                <mat-hint class="d-block mat-caption text-blue font-italic">
                    {{ 'form.documents-help' | translate: { size: 6 } }}
                </mat-hint>
            </h3>
            <ng-container *ngIf="client.allowMultipleUploadDocument">
                <h3 class="mat-subheading-1 text-muted font-weight-bold">
                    {{ 'form.document-types.' + client.docType | translate }}
                    <mat-hint class="d-block mat-caption font-italic">{{ 'form.choose-an-option' | translate }}</mat-hint>
                </h3>
                <mat-radio-group
                    [name]="'uploadDocumentMultipleYesNo'"
                    [(ngModel)]="client.uploadMultipleEnabled"
                    [required]="true"
                    [disabled]="isDisabled"
                >
                    <div class="row mb-3">
                        <div class="col-6 my-lg-auto my-0">
                            <mat-radio-button [name]="'uploadMultipleYes'" color="blue-gray" [value]="true">
                                {{ 'form.attach-sides-separatly' | translate }}
                            </mat-radio-button>
                            <img
                                src="assets/images/upload-file-multiple.svg"
                                width="100"
                                class="ml-2 mb-1"
                                [alt]="'form.attach-sides-separatly' | translate"
                            />
                        </div>
                        <div class="col-6 col-sm-6 my-auto">
                            <mat-radio-button [name]="'uploadMultipleNo'" color="blue-gray" [value]="false" class="align-top">
                                {{ 'form.attach-sides-together' | translate }}
                            </mat-radio-button>
                            <img
                                src="assets/images/upload-file-single.svg"
                                width="40"
                                class="ml-2"
                                [alt]="'form.attach-sides-together' | translate"
                            />
                        </div>
                    </div>
                </mat-radio-group>
            </ng-container>

            <ng-template ngFor let-document [ngForOf]="documents" let-i="index">
                <ng-container *ngIf="!document.iconPath">
                    <h3 class="mat-subheading-1 text-muted font-weight-bold">
                        {{ document.originalName }}
                    </h3>
                </ng-container>
                <div class="mb-3 mb-sm-4">
                    <thr-file-selector
                        [name]="'fdpDocument' + i"
                        [label]="document.isGuardianShip || document.iconPath ? document.name : ''"
                        [filename]="document.filename"
                        [canView]="document.id && !document.file"
                        filesize
                        filetype
                        [required]="!document.optional && (!document.id || document.remove)"
                        [disabled]="isDocumentDisabled(document)"
                        [iconPath]="document.iconPath"
                        [(ngModel)]="document.file"
                        (view)="onDocumentView(document)"
                        (remove)="onDocumentRemove(document)"
                        #documentCtrl="ngModel"
                    ></thr-file-selector>
                    <mat-error
                        class="d-block mat-caption font-italic mt-2"
                        *ngIf="documentCtrl.hasError('filetype') && !documentCtrl.hasError('required')"
                    >
                        {{ 'form.validation.filetype' | translate }}
                    </mat-error>
                    <mat-error
                        class="d-block mat-caption font-italic mt-2"
                        *ngIf="documentCtrl.hasError('filesize') && !documentCtrl.hasError('required')"
                    >
                        {{ 'form.validation.filesize' | translate: { size: 6 } }}
                    </mat-error>
                    <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="documentCtrl.hasError('required')">
                        {{ 'form.validation.required' | translate }}
                    </mat-error>
                </div>
            </ng-template>
        </div>
    </div>
</ng-container>
